import './vendor.module';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { CasModule } from './app/cas.module';
import { environment, initalizeEnvironment } from './environments/environment';

import 'hammerjs';

if (environment.production) {
    enableProdMode();
    disableConsoleLogs();
}

const loadConfiguration = fetch('config.json', {cache: 'reload'})
    .then(r => r.json())
    .then(config =>
        initalizeEnvironment(config)
    );

document.addEventListener('DOMContentLoaded', () => {
    loadConfiguration.then(() => {
        platformBrowserDynamic().bootstrapModule(CasModule)
            .then(() => {});
    });
});

function disableConsoleLogs() {
    // tslint:disable-next-line: no-console
    console.log = () => {
    };
}
